module.exports = __webpack_public_path__ + "img/gtc100d.4c6f36e6.png";